<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        class="filter-item"
        v-model="listQuery.hotel_name"
        placeholder="酒店名称"
        style="width: 220px"
        clearable
        size="mini"
      />
      <el-input
        class="filter-item"
        v-model="listQuery.order_sn"
        placeholder="隧穿订单号"
        style="width: 220px"
        clearable
        size="mini"
      />
      <el-input
        class="filter-item"
        v-model="listQuery.tr_order_sn"
        placeholder="分销商订单号"
        style="width: 220px"
        clearable
        size="mini"
      />
      <el-select
        class="filter-item"
        v-model="listQuery.status"
        placeholder="订单状态"
        style="width: 160px"
        clearable
        size="mini"
      >
        <el-option label="待支付" value="pending_payment" />
        <el-option label="已支付" value="paid" />
        <el-option label="已确认" value="confirmed" />
        <el-option label="已入住" value="checked_in" />
        <el-option label="已完成" value="completed" />
        <el-option label="已取消" value="canceled" />
        <el-option label="退款中" value="refunding" />
        <el-option label="已退款" value="refunded" />
      </el-select>
      <el-date-picker
        class="filter-item"
        v-model="dateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="入住开始日期"
        end-placeholder="入住结束日期"
        value-format="yyyy-MM-dd"
        size="mini"
        @change="handleDateChange"
      />

      <el-button
        class="filter-item"
        type="primary"
        @click="handleFilter"
        size="mini"
        >搜索</el-button
      >
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      size="mini"
    >
      <el-table-column label="隧穿订单号" min-width="180" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_sn }}
        </template>
      </el-table-column>

      <el-table-column label="分销商订单号" min-width="180" align="center">
        <template slot-scope="scope">
          {{ scope.row.tr_order_sn || '-' }}
        </template>
      </el-table-column>

      <el-table-column label="酒店名称" min-width="150" align="center">
        <template slot-scope="scope">
          {{ scope.row.hotel_name }}
        </template>
      </el-table-column>

      <el-table-column label="房型名称" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.room_name }}
        </template>
      </el-table-column>

      <el-table-column label="政策名称" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.policy_name }}
        </template>
      </el-table-column>

      <el-table-column label="入住日期" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.check_in_date }}
        </template>
      </el-table-column>

      <el-table-column label="离店日期" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.check_out_date }}
        </template>
      </el-table-column>

      <el-table-column label="间夜数" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.nights_num }}
        </template>
      </el-table-column>

      <el-table-column label="房间数" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.room_count }}
        </template>
      </el-table-column>

      <el-table-column label="联系人姓名" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>

      <el-table-column label="联系人电话" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.phone }}
        </template>
      </el-table-column>

      <el-table-column label="最晚到店时间" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.arrival_time || '-' }}
        </template>
      </el-table-column>

      <el-table-column label="订单价格" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_price }}
        </template>
      </el-table-column>

      <el-table-column label="退款金额" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.refund_price || '-' }}
        </template>
      </el-table-column>

      <el-table-column label="订单状态" min-width="140" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 'pending_payment'" type="warning"
            >待支付</el-tag
          >
          <el-tag v-else-if="scope.row.status === 'paid'" type="success"
            >已支付</el-tag
          >
          <el-tag v-else-if="scope.row.status === 'confirmed'" type="primary"
            >已确认</el-tag
          >
          <el-tag v-else-if="scope.row.status === 'checked_in'" type="info"
            >已入住</el-tag
          >
          <el-tag v-else-if="scope.row.status === 'completed'" type="success"
            >已完成</el-tag
          >
          <el-tag v-else-if="scope.row.status === 'canceled'" type="danger"
            >已取消</el-tag
          >
          <el-tag v-else-if="scope.row.status === 'refunding'" type="warning"
            >退款中</el-tag
          >
          <el-tag v-else-if="scope.row.status === 'refunded'" type="danger"
            >已退款</el-tag
          >
          <el-tag
            v-else-if="scope.row.status === 'confirmed_refunding_all_refunded'"
            type="success"
            >全部退款退款完成</el-tag
          >
          <el-tag v-else type="info">{{ scope.row.status }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column
        v-if="$canEdit"
        label="操作"
        width="250"
        align="center"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button type="warning" size="mini" @click="syncOrder(scope.row)"
            >同步订单</el-button
          >
          <el-button
            type="warning"
            size="mini"
            @click="cancelOrder(scope.row)"
            :disabled="
              scope.row.status === 'canceled' ||
              scope.row.status === 'completed'
            "
            >取消订单</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[5, 10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      dateRange: null,
      listQuery: {
        page: 1,
        limit: 10,
        hotel_name: '',
        order_sn: '',
        status: '',
        tr_order_sn: '',
        start_date: '',
        end_date: '',
      },
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/suiChuan/order/orderList',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.items
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    handleDateChange(val) {
      if (val) {
        this.listQuery.start_date = val[0]
        this.listQuery.end_date = val[1]
      } else {
        this.listQuery.start_date = ''
        this.listQuery.end_date = ''
      }
      this.listQuery.page = 1
      this.getList()
    },
    syncOrder(row) {
      this.$confirm('确认继续该操作', '提示', {
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/suiChuan/order/syncOrder',
            method: 'post',
            data: {
              order_sn: row.order_sn,
            },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功',
            })
          })
        })
        .catch(() => {})
    },
    cancelOrder(row) {
      this.$confirm('确认继续该操作', '提示', {
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/suiChuan/order/cancelOrder',
            method: 'post',
            data: {
              order_sn: row.order_sn,
            },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功',
            })
          })
        })
        .catch(() => {})
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped></style>
